module.exports = __webpack_public_path__ + "static/img/Nick-Cotric.67056fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nick-Cotric.jpg
// module id = xV4b
// module chunks = 0